import * as types from './chart.types';
import * as constants from './chart.constants';
import { IOrganizationChartNode } from '../../../resource/node/node.types';
import { IChart } from '../../../resource/chart/chart.types';

export const storeChart = (chartNodes: IOrganizationChartNode['id'][]): types.IStoreChart => ({
  type: constants.STORE_CHART,
  payload: chartNodes,
});

export const clearChart = (): types.IClearChart => ({
  type: constants.CLEAR_CHART,
});

export const refreshChart = (refresh: number): types.IRefreshChart => ({
  type: constants.REFRESH_CHART,
  payload: refresh,
});

export const clearRefreshChart = (): types.IClearRefreshChart => ({
  type: constants.CLEAR_REFRESH_CHART,
});

export const storeIsFetched = (): types.IStoreIsFetched => ({
  type: constants.STORE_IS_FETCHED,
});

export const clearIsFetched = (): types.IClearIsFetched => ({
  type: constants.CLEAR_IS_FETCHED,
});

export const storeChartVersions = (versions: IChart[]): types.IStoreChartVersions => ({
  type: constants.STORE_CHART_VERSIONS,
  payload: versions,
});

export const setSelectedChartId = (chartId: IChart['id'] | null): types.ISetSelectedChartId => ({
  type: constants.SET_SELECTED_CHART_ID,
  payload: chartId,
});

export const setDraftSelected = (isDraftSelected: boolean): types.ISetDraftSelected => ({
  type: constants.SET_DRAFT_SELECTED,
  payload: isDraftSelected,
});

export const clearChartEditState = (): types.IClearChartEditState => ({
  type: constants.CLEAR_CHART_EDIT_STATE,
});
